import { useCallback, useState } from "react";
import type { AIToolLibraryTab } from "../components/AIToolLibraryModal";
import type { AIToolLibraryConfig } from "./useAIToolLibrary";

interface UseAIToolLibraryModalReturn {
  isLibraryOpen: boolean;
  activeTab: AIToolLibraryTab;
  openLibrary: (config?: AIToolLibraryConfig) => void;
  closeLibrary: () => void;
  switchTab: (tab: AIToolLibraryTab) => void;
}

export const useAIToolLibraryModal = (): UseAIToolLibraryModalReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<AIToolLibraryTab>("templates");

  const openLibrary = useCallback((config?: AIToolLibraryConfig) => {
    setActiveTab(config?.tab || "templates");
    setIsOpen(true);

    // TODO (Will) upon new template or tone creation set the templateID or voiceID in the config
    // so that we can preselect it for the user
  }, []);

  const closeLibrary = useCallback(() => {
    setIsOpen(false);
  }, []);

  const switchTab = useCallback((tab: AIToolLibraryTab) => {
    setActiveTab(tab);
  }, []);

  return {
    isLibraryOpen: isOpen,
    activeTab,
    openLibrary,
    closeLibrary,
    switchTab,
  };
};
